module.exports = __webpack_public_path__ + "img/choose-up-12_3 virtual_text.e13f965b.png";